import React from "react";

import Box from "veneer/Box";

import type { Media } from "cortex/ui/src/fleet/view/media-library/model";
import { ContentArchived } from "cortex/ui/src/ui/content-archived";

import { ContentPreview } from "./ContentPreview";
import { EditContentForm } from "./EditContentForm";
import { type FormConfig, type GetChildState } from "./sidebarTypes";

interface ContentEditorProps {
  categories?: ReadonlyArray<string>;
  getChildState?: GetChildState;
  getConfig: (type?: string | null, mimeType?: string | null) => FormConfig;
  hideFullscreen?: () => void;
  mediaEntry?: Partial<Media>;
  showFullscreen?: (
    url: string,
    mediaType: "image" | "video" | null,
    filename?: string,
  ) => void;
}

export function ContentEditor({
  categories = [],
  getChildState = () => {},
  getConfig,
  hideFullscreen = () => {},
  mediaEntry = {},
  showFullscreen = () => {},
}: ContentEditorProps) {
  const { mimeType, name, type, url } = mediaEntry;
  const { excludeFields, readOnlyFields } = getConfig(type, mimeType);

  return (
    <Box dataTestId="content-editor">
      <ContentPreview
        hideFullscreen={hideFullscreen}
        mimeType={mimeType ?? undefined}
        name={name ?? undefined}
        showFullscreen={showFullscreen}
        type={type ?? undefined}
        url={url ?? undefined}
      />
      <Box mt={1}>
        <ContentArchived mediaEntry={mediaEntry} />
      </Box>
      <EditContentForm
        categories={categories}
        excludeFields={excludeFields}
        getState={getChildState}
        mediaEntry={mediaEntry}
        readOnlyFields={readOnlyFields}
      />
    </Box>
  );
}
